import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DataService } from './data.service';

export interface Email2faStartResponse {
  accountId: number;
  sent: boolean;
  maskedEmail: string;
}

export interface Email2faStatusResponse {
  accountId: number;
  verified: boolean;
  maskedEmail?: string | null;
}

export interface Email2faVerifyResponse {
  accountId: number;
  verified: boolean;
}

@Injectable()
export class AccountEmail2faService {
  constructor(private data: DataService) {}

  start(accountId: number): Observable<Email2faStartResponse> {
    return this.data.post(`api/email-2fa/accounts/${accountId}/start`, {});
  }

  status(accountId: number): Observable<Email2faStatusResponse> {
    return this.data.get(`api/email-2fa/accounts/${accountId}/status`);
  }

  verify(accountId: number, code: string): Observable<Email2faVerifyResponse> {
    return this.data.post(`api/email-2fa/accounts/${accountId}/verify`, { code });
  }
}
